import { ReactComponent as MessageIcon } from "@assets/icons/message.svg";
import { ReactComponent as PennyIcon } from "@assets/icons/penny_icon.svg";
import { ReactComponent as FlagIcon } from "@assets/icons/flag.svg";
import { ReactComponent as UserChecked } from "@assets/icons/user_checked.svg";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import BottomBarDesktop from "@components/BottomBars/BottomBarDesktop";
import ModalFactFindEligibility from "@components/Modals/ModalFactFindEligibility";
import BarStepsProgressVertical from "@components/Progress/BarStepsProgressVertical";
import HeaderProgress from "@components/Progress/HeaderProgress";
import BottomBar from "@components/BottomBars/BottomBar";

type FactFindIntroProps = {};

const FactFindIntro: React.FC<FactFindIntroProps> = () => {
  const navigate = useNavigate();
  const [openModalHandyFactFind, setOpenModalHandyFactFind] = useState(false);

  const handleQualification = () => {
    navigate("/fact-find/qualification");
  };

  return (
    <>
      <ModalFactFindEligibility
        onClose={() => setOpenModalHandyFactFind(false)}
        open={openModalHandyFactFind}
      />

      <section className="grow flex items-start md:items-center justify-center border-t-4 border-l-0 md:border-t-0 md:border-l-4 border-[#F4E34E] px-0 md:px-2 lg:px-0">
        <div className="max-w-full md:max-w-[846px] w-full md:rounded-3xl md:border md:border-pn_gray-200">
          <HeaderProgress splited={1} closeButtonEvent={() => navigate("/")} />

          <div className="flex items-start md:items-start flex-col md:flex-row">
            <div className="flex-1 p-0 md:p-6 flex flex-col">
              <div className="p-4 flex flex-col gap-y-6">
                <div className="bg-[#F4E34E] rounded-full w-[60px] h-[60px] flex items-center justify-center">
                  <PennyIcon className="w-[24px] h-[27px]" />
                </div>

                <div className="flex flex-col gap-y-1">
                  <span className="text-pn-large-title text-pn_gray-950">
                    Eligibility Quiz
                  </span>
                  <span className="text-pn-headline-regular md:text-pn-body-large-regular text-pn_gray-600">
                    We need to ask these questions for regulatory reasons. Don't
                    worry, most people are eligible
                  </span>
                </div>
              </div>

              <div className="p-4 flex flex-col gap-y-4">
                <div className="py-4 px-6 border-l-2 border-pn_cyan-500 bg-pn_white rounded-tr-2xl rounded-br-2xl flex items-center gap-x-4">
                  <div className="bg-pn_cyan-100 rounded-full w-10 h-10 flex items-center justify-center">
                    <MessageIcon />
                  </div>
                  <span className="flex-1 text-pn-body-small-regular text-pn_black">
                    You will find out instantly if you are eligible. From there
                    the process takes around{" "}
                    <span className="text-pn-callout-emphasis">5-10</span>{" "}
                    minutes to complete
                  </span>
                </div>

                <div className="md:block hidden">
                  <button
                    onClick={() => setOpenModalHandyFactFind(true)}
                    className="btn-tertiary-xs-semibold text-pn_gray-950 py-1"
                  >
                    See the list of documents you should have handy
                  </button>
                </div>
              </div>
            </div>

            <div className="flex-1 pt-4 pb-0 px-4  md:py-6 md:pl-6 md:pr-8 flex flex-col">
              <div className="pb-4 md:py-1">
                <span className="text-pn-body-large-emphasis">
                  Pension Overview
                </span>
              </div>

              <div className="p-6 border border-pn_gray-200 rounded-2xl bg-pn_white">
                <BarStepsProgressVertical activeStep={1} />
              </div>
            </div>
          </div>

          <div className="md:hidden flex flex-col">
            <div className="p-4">
              <span className="text-pn-body-large-emphasis">
                Paperwork to have handy
              </span>
            </div>

            <div className="px-4">
              <div className="flex flex-col border border-pn_gray-200 bg-pn_white py-2 rounded-2xl">
                <div className="p-4 flex items-center gap-x-4">
                  <div className="w-10 h-10 rounded-full bg-pn_gray-200 flex items-center justify-center">
                    <FlagIcon className="w-6 h-6" />
                  </div>
                  <div className="flex flex-col gap-y-1 flex-1">
                    <span className="text-pn-callout-emphasis text-pn_gray-950">
                      Proof of PPSN
                    </span>
                    <span className="text-pn-body-small-regular">
                      Personal Public Service Number
                    </span>
                  </div>
                </div>

                <div className="p-4 flex items-center gap-x-4">
                  <div className="w-10 h-10 rounded-full bg-pn_gray-200 flex items-center justify-center">
                    <UserChecked className="w-6 h-6" />
                  </div>
                  <div className="flex flex-col gap-y-1 flex-1">
                    <span className="text-pn-callout-emphasis text-pn_gray-950">
                      Identity Document
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="p-4 text-pn-body-small-regular text-pn_gray-950">
              Your PPS document must be legible and display clearly. Having
              trouble? You can contact Revenue for any PPSN related queries:{" "}
              <Link
                className="text-pn-callout-link text-pn_cyan-500"
                to="https://www.revenue.ie"
              >
                www.revenue.ie
              </Link>
            </div>
          </div>

          <div className="hidden md:block">
            <BottomBarDesktop
              labelNext="Start Quiz"
              onNext={handleQualification}
              message="Penny recommendation is ~8min away"
              insideCard
            />
          </div>

          <div className="block md:hidden">
            <BottomBar
              layout="message"
              labelNext="Start Quiz"
              onNext={handleQualification}
              message="Penny recommendation is ~8min away"
            />
          </div>
        </div>
      </section>
    </>
  );
};
export default FactFindIntro;
